// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nspan.field[data-v-05542d1d]{ background: var(--main-gray-1); padding: 2px 4px; border-radius: 2px; color:var(--main-gray-6); border:1px solid var(--main-gray-2);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
